import { useMemo } from "react";
import { PublicLayout, Title, useAuth } from "../../components";
import ContentWrapper from "../../components/layout/ContentWrapper";
import { useCustomTranslation } from "../../helpers/translateHelpers";
import AccountsList from "./components/AccountsList";
import { Trans } from "react-i18next";
import { useGetLinkedContactPeopleQuery } from "./queries";

const AccountSelectPage = () => {
  const { tCommon } = useCustomTranslation();

  const { user } = useAuth();

  const linkedContactPeopleQuery = useGetLinkedContactPeopleQuery();

  const activeAccounts = useMemo(
    () =>
      linkedContactPeopleQuery.data?.contactPeople.filter(
        (x) => !x.customerUserIsDisabled,
      ) ?? [],
    [linkedContactPeopleQuery.data?.contactPeople],
  );

  const disabledAccounts = useMemo(
    () =>
      linkedContactPeopleQuery.data?.contactPeople.filter(
        (x) => x.customerUserIsDisabled,
      ) ?? [],
    [linkedContactPeopleQuery.data?.contactPeople],
  );

  return (
    <PublicLayout>
      <ContentWrapper largePadding loading={linkedContactPeopleQuery.isLoading}>
        <Title
          title={tCommon("access_restricted")}
          size="big"
          className="text-primary"
        />
        <p className="mb-6">
          <Trans
            i18nKey="access_restricted_description"
            ns="customerportal-common"
            values={{
              companyName: user?.companyName,
              customerName: user?.customerName,
            }}
          />
        </p>
        {activeAccounts.length > 0 && (
          <AccountsList
            contactPeople={activeAccounts}
            title={tCommon("account_select_active")}
          />
        )}
        {disabledAccounts.length > 0 && (
          <AccountsList
            contactPeople={disabledAccounts}
            title={tCommon("account_select_disabled")}
            description={tCommon("account_select_disabled_description")}
          />
        )}
      </ContentWrapper>
    </PublicLayout>
  );
};

export default AccountSelectPage;
